import * as Yup from 'yup';

export function getQuoteNotesInitialValues(editResponse, editFlag) {
  return {
    notes: editResponse?.notes ? editResponse.notes : ""
  };
}

const VALIDATION_SCHEMA = () => {
      let schemaAttributes = {
        notes:Yup.string().trim().required('Notes is required.')
      };
      return Yup.object().shape(schemaAttributes);
}
export { VALIDATION_SCHEMA };
